import React from "react";

import { DropDownField, TextInputField } from "../../../helpers";


const SelectStateNew = (props) => {
    const { buyerQuote, setBuyerQuote, allCompanyBillAddresses, procmartStates, statesDetails, pmBillAddresses, selectedProcState, setSelectedProcmartState } = props

    const handleProcmartState = (e, buyerQuote, setBuyerQuote) => {
        const selectedBillAddr = pmBillAddresses.find(eachBillAddrr => eachBillAddrr.stateId === e.target.value)
        
        setBuyerQuote({ ...buyerQuote, pmBillAddrId: selectedBillAddr?.billAddrId ? selectedBillAddr?.billAddrId : null })
        if(selectedBillAddr){
            setSelectedProcmartState(selectedBillAddr.stateId)
        }
    }

    const buyerBillAddr = allCompanyBillAddresses.find(eachBillAddr => eachBillAddr.billAddrId === buyerQuote?.billAddrId)
    const buyerState = statesDetails.find(eachState => eachState.stateId === buyerBillAddr?.stateId)
    
    return(
        <div className="p-card mb-0">
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <DropDownField name="procmart state" value={selectedProcState} labelText="Procmart State" options={procmartStates} optionLabel="stateName" optionValue="stateId" onChange={(e) => {handleProcmartState(e, buyerQuote, setBuyerQuote)}} />  
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <TextInputField name="buyer state" value={buyerState?.stateName} disabled labelText="Buyer State" />
                </div>
            </div>
        </div>
    )
}

export default SelectStateNew;